import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  root: {
    flex: 1,
    gap: spacing(0.5),
  },
  channelPageRow: {
    flexDirection: "row",
    alignItems: "stretch",
  },
  channelGroupPage: {
    flexDirection: "row",
  },
  channelGroupPlaceholder: {
    height: "100%",
  },
}));

export default stylesheet;
